import { exposeFunctions } from "./core.js";
import { _fetch, getCookie, setCookie } from "./fetch.js";

export let i18nSupported = true;
export let currentLanguage = null;

const translationsMap = {};

/**
 * Translate: obtain the string for the key based on current language.
 *
 * @param {string} key
 * @returns {string}
 */
export function tl(key) {
	if (!key || !currentLanguage)
		return key;
	const translations = translationsMap[currentLanguage]
	if (!translations)
		return key;
	const value = translations[key];
	return value ? value : key;
}

/**
 * @param {string} language
 * @returns {Promise<boolean>}
 */
export async function fetchLanguageTranslations(language) {
	if (!i18nSupported)
		return false;

	if (!language) {
		if (currentLanguage)
			language = currentLanguage;

		if (!language)
			language = getCookie('Language');

		if (!language)
			language = document.documentElement.lang;

		if (!language) {
			i18nSupported = false;
			return false;
		}
	}

	if (currentLanguage == language)
		return true;

	if (translationsMap[language]) {
		currentLanguage = language;
		return true;
	}

	const v = window["i18nAssetsVersion"];
	const path = `/i18n/${language}.json?v=${v}`;
	const response = await _fetch(path);

	if (!response.ok)
		return false;

	const data = await response.json();
	translationsMap[language] = data;
	currentLanguage = language;
	return true;
}

function updateElements() {
	const from = Date.now();
	const elems = document.querySelectorAll('[data-i18n-text], [data-i18n-title], [data-i18n-placeholder]');

	for (let i = 0; i < elems.length; i++) {
		const elem = /** @type {HTMLElement} */ (elems[i]);

		if (elem.dataset.i18nText)
			elem.textContent = tl(elem.dataset.i18nText);

		if (elem.dataset.i18nTitle)
			elem.setAttribute('title', tl(elem.dataset.i18nTitle));

		if (elem.dataset.i18nPlaceholder)
			elem.setAttribute('placeholder', tl(elem.dataset.i18nPlaceholder));
	}
	const diff = Date.now() - from;
	console.debug(`Updated ${elems.length} elements in ${diff} ms.`);
}

export async function changeLanguage(language) {
	const ok = await fetchLanguageTranslations(language);
	if (ok && language) {
		document.documentElement.lang = language;

		const years = 10 * 365 * 24 * 60 * 60;
		setCookie('Language', language, "/", years);

		document.dispatchEvent(new Event("languageChanged"));
		updateElements();
	}
}

/**
 * Add or remove a listener for language change events.
 * @param {boolean} listen
 * @param {EventListenerOrEventListenerObject} listener
 */
export function listenToLanguageChange(listen, listener) {
	if (listener && i18nSupported) {
		if (listen)
			document.addEventListener("languageChanged", listener);
		else
			document.removeEventListener("languageChanged", listener);
	}
}

exposeFunctions({ tl, changeLanguage, listenToLanguageChange });

export default tl;

